//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { httpAction } from '@/api/manage';
export default {
  name: 'AssetsConfigModal',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '操作',
      visible: false,
      form_fields: ['insideNumber', 'insideName', 'location', 'status'],
      validatorRules: {
        insideNumber: {
          rules: [{
            required: true,
            message: '请输入内部编号!'
          }]
        }
      },
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      labelCol3: {
        xs: {
          span: 24
        },
        sm: {
          span: 2
        }
      },
      wrapperCol3: {
        xs: {
          span: 24
        },
        sm: {
          span: 19
        }
      },
      model: {},
      confirmLoading: false,
      status: '1',
      url: {
        edit: '/ea/asset/info'
      }
    };
  },
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form.setFieldsValue(timeVal);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData.id = formData.assetId;
          var method = 'put';
          httpAction(_this2.url.edit, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};